import { CSSProperties, SVGAttributes } from 'react';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;
const dash = keyframes`
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
`;

const Svg = styled.svg<
  SVGAttributes<HTMLElement> & {
    size?: number;
  }
>`
  animation: ${rotate} 2s linear infinite;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;

  & circle {
    stroke: currentColor;
    /* stroke: hsl(210, 70, 75); */
    stroke-linecap: round;
    animation: ${dash} 1.5s ease-in-out infinite;
  }
`;

export const Spin = ({
  style,
  size = 22,
}: {
  style?: CSSProperties;
  size?: number;
}) => {
  return (
    <Svg viewBox="0 0 50 50" style={style} size={size}>
      <circle cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
    </Svg>
  );
};
